export default __webpack_public_path__ + "static/media/Brow_1_C2.ffa3158e.svg";